import { ThemeUICSSObject } from 'theme-ui';
import getColorsAndStatesByPath from '../../../colors/util/getColorsAndStatesByPath';

export const secondary: ThemeUICSSObject = {
  variant: 'layout.common.tables.primary',
  borderColor: 'components.secondaryTable.borderColor',

  '& thead': {
    'tr:not(.filtersRow):not(.responsiveTable__filters__row)': {
      '& th, & td': () => ({
        ...getColorsAndStatesByPath('components.secondaryTable.header'),
      }),
    },
  },
  '& tbody': {
    tr: {
      '&:nth-of-type(2n)': {
        backgroundColor:
          'components.secondaryTable.body.evenRowsBackgroundColor',
      },

      td: {
        borderColor: 'components.secondaryTable.body.borderColor',
      },

      '&[aria-selected="true"]': {
        backgroundColor:
          'components.secondaryTable.body.selectedRows.backgroundColor',

        color: 'components.secondaryTable.body.selectedRows.color',
      },

      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      ...getColorsAndStatesByPath('components.secondaryTable.body', {
        states: {
          disabled: false,
          readonly: false,
          active: false,
          hover: false,
          checked: false,
          focus: false,
          selected: false,
        },
      }),
    },
  },
};
